import "./Home.css";
import gsap from "gsap";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LOGOfile from "../../sanyamLogo.png";

var NewComponent = () => {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from("#Sanyam_jain", { duration: 1, opacity: 0, y: "100%" }, 1);
    tl.from("#designerSpan", { duration: 1, opacity: 0, y: "-100%" }, 1);
    tl.from("#Hire_Me", { duration: 1, opacity: 0, y: "100%" });
  }, []);
  const [backCol, setBackCol] = useState("black");
  const [textCol, settextCol] = useState("white");
  const [opa, setopa] = useState(0);
  return (
    <div>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Home</title>
      <link
        rel="stylesheet"
        type="text/css"
        id="applicationStylesheet"
        href="Home.css"
      />
      <div
        id="Home"
        style={{ backgroundColor: backCol, transitionDuration: "2000ms" }}
      >
        <div id="menu">
          <div id="menu_text">
            <span className="menuItems" style={{ fontSize: "2rem" }}>
              <Link to="/">Home</Link>
            </span>
            <span className="menuItems">
              <Link to="/about">About</Link>
            </span>

            <span className="menuItems">
              <Link to="/work">Works</Link>
            </span>

            <span className="menuItems">
              <Link to="/contact">Contact</Link>
            </span>
          </div>
        </div>

        <div
          id="designer"
          onMouseOver={() => {
            setBackCol("white");
            settextCol("red");
            setopa(1);
          }}
          onMouseLeave={() => {
            setBackCol("black");
            settextCol("white");
            setopa(0);
          }}
          style={{
            color: textCol,
            transitionDuration: "2000ms",
            cursor: "pointer",
          }}
        >
          <div id="designerSpan">designer.</div>
        </div>
        <div
          onClick={() => {
            window.location.href = "mailto:jain77sanyam@gmail.com";
          }}
          id="Hire_Me"
        >
          <span id="HMspan">Hire Me</span>
        </div>
        <div id="Sanyam_jain">
          <span>Sanyam jain</span>
        </div>
        <div id="logo" style={{ opacity: opa, transitionDuration: "2000ms" }}>
          <img height="200px" src={LOGOfile} alt="" />
        </div>
      </div>
    </div>
  );
};

export default NewComponent;
